<template>
  <div>
    <a-row>
      <g-master name="ActionGroupsItems"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                :modalFieldsSetup="master.modalFieldsSetup"
                modalWidth="60%"
                ref="master"
                @action="masterAction"
                :beforeSend="beforeSend"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Etiqueta')">
                <a-input
                  v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Tipo De Acción')">
                <a-select v-bind="selOptions"
                          v-decorator="['action_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                  <a-select-option v-for="accion in typeAcciones" :key="accion.value"> {{ accion.value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Orden')" v-bind="fiOptions">
                <a-input-number
                  v-decorator="['sort_order', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  style="width: 100%">
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Tipo De Botón')">
                <a-select v-bind="selOptions"
                          v-decorator="['btn_type', { rules: [{ required: false, message: 'Valor requerido', allowClear: true }] }]">
                  <a-select-option v-for="boton in typeBotones" :key="boton.value"> {{ boton.value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Icono')">
                <a-input
                  v-decorator="['btn_icon', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Roles')"
                          :selectConfig="{mode:'multiple'}"
                          :formItemConfig="fiOptions"
                          endpoint="role"
                          :decorator="['roles']">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Confirmación')">
                <a-checkbox
                  v-decorator="['confirm', {valuePropName: 'checked',  rules: [{ required: false, message: 'Valor requerido'}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Usa Descarga?')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['use_download', {valuePropName: 'checked',  rules: [{ required: false, message: 'Valor requerido'}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['active', {valuePropName: 'checked',  rules: [{ required: false, message: 'Valor requerido'}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Mensaje De Confirmacion')">
                <a-textarea
                  v-decorator="['confirm_message', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Acción')">
                <a-textarea
                  v-decorator="['action', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '../../../../../util/JsUtils'

  export default {
    props: ['id_action_group'],
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        typeAcciones: [
          {value: 'PHP'},
          {value: 'JS'},
          {value: 'PL'}
        ],
        typeBotones: [
          {value: 'primary'},
          {value: 'default'},
          {value: 'danger'},
          {value: 'dashed'}
        ],
        master: {
          endpoint: 'action_group_items',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'label', sorter: true},
              {title: 'Ventana De Confirmacion', dataIndex: 'confirm_desc', sorter: true},
              {title: 'Mensaje De Confirmacion', dataIndex: 'confirm_message', sorter: true},
              {title: 'Roles', dataIndex: 'roles', sorter: true},
              {title: 'Accion', dataIndex: 'action', sorter: true},
              {title: 'Tipo De Accion', dataIndex: 'action_type', sorter: true},
              {title: 'Tipo De Botón', dataIndex: 'btn_type', sorter: true},
              {title: 'Icono', dataIndex: 'btn_icon', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true},
              {title: 'Descargar', dataIndex: 'use_download', sorter: true},
              {title: 'Orden', dataIndex: 'sort_order', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'label'},
            {name: 'confirm'},
            {name: 'confirm_message'},
            {name: 'roles'},
            {name: 'action'},
            {name: 'action_type'},
            {name: 'btn_type'},
            {name: 'btn_icon'},
            {name: 'active'},
            {name: 'use_download'},
            {name: 'sort_order'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_action_group: this.id_action_group
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$refs.master.modal.form.setFieldsValue({
              roles: JsUtils.isEmpty(action.record.roles) ? [] : action.record.roles.split(',')
            })
            break
        }
      },
      beforeSend (data) {
        if (!this.$isEmpty(data.roles)) {
          data.roles = data.roles.join(',')
        } else {
          data.roles = ''
        }
        return data
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/ActionGroups/ActionGroupsItems.vue